export default __webpack_public_path__ + "static/media/state-0.af36aa09.svg";